import { cx } from '../../utils/cx';
import s from './ProgressSteps.module.css';

export type ProgressStepsProps = {
  total: number;
  current: number;
  /** Accessible name for the progress bar. */
  label?: string;
  className?: string;
};

/** Onboarding progress: "Step 2 of 3" for screen readers, chunky pills on screen. */
export function ProgressSteps({
  total,
  current,
  label = 'Onboarding progress',
  className,
}: ProgressStepsProps) {
  return (
    <div
      className={cx(s.steps, className)}
      role="progressbar"
      aria-label={label}
      aria-valuemin={1}
      aria-valuemax={total}
      aria-valuenow={current}
      aria-valuetext={`Step ${current} of ${total}`}
    >
      {Array.from({ length: total }, (_, i) => (
        <span key={i} className={s.step} data-done={i < current || undefined} />
      ))}
    </div>
  );
}
